import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]

import useAltaPay from '@/shared/checkout/altapay/useAltaPay';
import { ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useAltaPayPaymentMethods from '@/shared/checkout/altapay/useAltaPayPaymentMethods';
import { useCheckout } from '../../useCheckout';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentFinalizeAltaPay',
  setup(__props) {

const labels = useBlockLabels();
const { selectedPaymentMethod } = useAltaPayPaymentMethods();
const { initiatePayment, initializing } = useAltaPay();
const { initializePayment, setItemIdsOutOfStock, setEarliestDeliveryDateChanged } = useCheckout();
const pending = ref<boolean>(false);

const updatePaymentAndInitialize = async() => {
    const result = await initializePayment();
    if (result.itemsOutOfStock?.length) {
        setItemIdsOutOfStock(result.itemsOutOfStock);
    } else if (result.requiredEarliestDeliveryDate) {
        setEarliestDeliveryDateChanged(true);
    } else {
        pending.value = true;
        await initiatePayment();
        pending.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "c-button c-button--primary",
    disabled: !_unref(selectedPaymentMethod) || pending.value || _unref(initializing),
    onClick: _withModifiers(updatePaymentAndInitialize, ["prevent"])
  }, _toDisplayString(_unref(labels).paymentStepButtonConfirmAndSubmit), 9, _hoisted_1))
}
}

})